import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "../../style/search.css"; // External CSS file
import { Card, Col, Dropdown, Menu, Row } from "antd";
import { Link, Redirect, Route, useHistory } from "react-router-dom";
import { stepKeyToPath } from "Components/Baselayout/StaticValues";
import { step_names } from "Components/Coachdashboard/StepNames";
import AUTH_API from "api/auth";
import HELPERS from "utils/helper";

const SearchBar = (props) => {
  const [showSearch, setShowSearch] = useState(false);
  const [timer, setTimer] = useState(null);
  const history = useHistory(); // ← useHistory hook
  const userId = HELPERS.getUserId();
  const searchBarRef=useRef()

  const dummyData = { "data": [
    {
      "content": "Lorem ipsum dount utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.", 
      "step": "AS",
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.", 
      "step": "TR"
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. quip ex ea commodo consequat.", 
      "step": "TI",
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.", 
      "step": "PS"
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.", 
      "step": "AG",
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.", 
      "step": "RR"
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.", 
      "step": "RI",
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.", 
      "step": "PE"
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.", 
      "step": "TH",
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.",
      "step": "RB"
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. ullamcolaboris nisi ut aliquip ex ea commodo consequat.",
      "step": "RB"
    },
    {
      "content": "ipsum dolor sit amet, adipiscing elit. eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.",
      "step": "RB"
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.",
      "step": "RB"
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.",
      "step": "RB"
    },
    {
      "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut aliquip ex ea commodo consequat.",
      "step": "RB"
    },
    {
      "content": "consectetur adipiscing elit. Sed do eiusmod tempor incididunt utlabore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcolaboris nisi ut .",
      "step": "RB"
    }
  ] }

  // Handle search input with debouncing (2-3s delay)
  const handleSearch = (e) => {
    props.setSearchLoading(true);
    const searchValue = e.target.value;
    props.setSearchQuery(searchValue);
    
    if (timer) clearTimeout(timer);

    if (!searchValue.trim()) {
      props.setSearchLoading(false);
      props.setSearchResults([]); // Clear results if input is cleared
      return;
    }

    setTimer(
      setTimeout(() => {
        fetchResults(searchValue);
        // console.log('sss searchValue', searchValue);
        history.push("/search-results"); // ← programmatic redirect
      }, 500) // Adjusted debounce time to ~2.5s
    );
  };

  // Fetch API results
  const fetchResults = async (searchQuery) => {
    if (!searchQuery.trim()) {
      props.setSearchLoading(false);
      props.setSearchResults([]);
      return;
    }
    props.setSearchQuery(searchQuery)

    try {
      // props.setSearchResults(dummyData.data);
      AUTH_API.searchResults(userId, searchQuery)
      .then((response) => {
        console.error("sss response", response, props.searchLoading);
        props.setSearchResults(response.data);
        props.setSearchLoading(false);
      })
      .catch((err) => {
        props.setSearchLoading(false);
        console.log("get api error", err);
      });
    } catch (error) {
      props.setSearchLoading(false);
      console.error("Error fetching search results:", error);
    }
  };

  const openSearchResults = () => {
    console.log('sss props.searchResult', props)
    return (
      <Menu className="">
        {
          Array.isArray(props.searchResults) && props.searchResults.map((item, index) => (
            <Menu.Item key={index} onClick={() => window.open(stepKeyToPath[item.step], "_blank", "noopener,noreferrer")} >
              <p>{step_names[item.step]}</p>
              <p>{item.content}</p>
            </Menu.Item>
          ))
        }
      </Menu>
    )
  }
  
  const HighlightMatch = (content, query) => {
    if (!content) return query; // If content is empty, show query

    const regex = new RegExp(`(${query})`, "gi");
    return content.split(regex).map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? <strong key={index}><mark>{part}</mark></strong> : part
    );
  };

  // Close search and reset state
  const handleCloseSearch = () => {
    setShowSearch(false);
    props.setSearchQuery("");
    props.setSearchLoading(false);
    props.setSearchResults([]); // Clear results when closing
    history.push("/dashboard")
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchBarRef.current && !searchBarRef.current.contains(event.target) && !window.location.pathname.endsWith("/search-results") ) {
        setShowSearch(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSearch]); 

  return (
    <div className="search-container" ref={searchBarRef}>
      {/* Search Icon (Click to Open Search Bar) */}
      {!showSearch && (
        <button onClick={() => setShowSearch(true)} className="search-button">
          <img src="https://django-woken-static.s3.amazonaws.com/static/media/searchicon.svg" alt="Search" />
        </button>
      )}

      {/* Search Bar */}
      {showSearch && (
        <div className="search-box">
          <img src="https://django-woken-static.s3.amazonaws.com/static/media/searchiconblue.svg" alt="Search" className="search-box-icon" />
          <input
            type="text"
            placeholder="Start Searching"
            value={props.searchQuery}
            onChange={handleSearch}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(e); // or trigger your actual search function here
              }
            }}
            className="search-input"
            />
          {/* Close (X) Button Inside Input */}
          <button onClick={handleCloseSearch} className="close-btn">
            <img src="https://django-woken-static.s3.amazonaws.com/static/media/searchcloseblue.svg" alt="Close" className="close-icon" />
          </button>
        </div>
      )}

      {/* Search Results Dropdown */}
      {
        // showSearch && props.searchResults.length > 0 && (
        //   <div className="search-results">
        //     {props.searchLoading && <p className="loading-text">Searching...</p>}
        //     {
        //       props.searchResults.filter(item => item.content.toLowerCase().includes(props.searchQuery.toLowerCase())).map((item, index) => (
        //         <div key={index} onClick={() => window.open(stepKeyToPath[item.step], "_blank", "noopener,noreferrer")} className="search-result-item">
        //           <p className="result-step">{step_names[item.step]}</p>
        //           {/* <p className="result-content">{item.content}</p> */}
        //           <p className="result-content">{HighlightMatch(item.content, props.searchQuery)}</p>
        //         </div>
        //       ))
        //     }
        //   </div>
        // )
      }
    </div>
  );
};

export default SearchBar;
